export default "__VITE_ASSET__DdKX9wnx__"